<div class="flex flex-col px-6 pt-6 items-center gap-2">
  <div class="flex items-center w-full">
    @if (data.svgIcon || data.icon) {
      <div class="grow size-6 shrink-0 flex items-center justify-center w-auto ml-10">
        @if (data.svgIcon) {
          <mat-icon [svgIcon]="data.svgIcon" class="!text-primary"></mat-icon>
        } @else {
          <mat-icon class="material-symbols-outlined !text-primary">{{ data.icon }}</mat-icon>
        }
      </div>
    } @else {
      <div class="grow"></div>
    }
    <button mat-icon-button
      (click)="onCancel()"
      class="w-auto"
      [attr.aria-label]="'Close' | translate">
      <mat-icon class="!text-on-surface-variant">close</mat-icon>
    </button>
  </div>
  <h1 class="headline-small text-primary flex-1 text-center">{{ data.title }}</h1>
</div>

<app-dialog-content>
  <div class="flex flex-col gap-6">
    @if (data.description) {
      <p
        class="whitespace-pre-line m-0"
        [class.body-large]="!!(data.svgIcon || data.icon)"
        [class.body-medium]="!(data.svgIcon || data.icon)"
        [class.text-center]="!(data.svgIcon || data.icon)"
        [class.text-on-surface-variant]="!(data.svgIcon || data.icon)">
        {{ data.description }}
      </p>
    }
    @if (data.warning) {
      <div class="flex items-center gap-2 w-full px-3 py-2 rounded-[4px] bg-tertiary-99 border border-tertiary-50">
        <mat-icon class="material-symbols-outlined !text-tertiary-30 shrink-0">warning</mat-icon>
        <p class="label-large !text-tertiary-30 m-0">{{ data.warning }}</p>
      </div>
    }
  </div>
</app-dialog-content>

<app-dialog-footer>
  <div class="flex items-center w-full mt-6 md:mt-10"
    [ngClass]="{
      'gap-1 md:gap-3': data.compactActions,
      'gap-1 md:gap-4': !data.compactActions,
      'justify-end': data.compactActions || data.cancelText,
      'justify-center': !data.compactActions && !data.cancelText
    }">
    @if (data.cancelText) {
      <button mat-stroked-button color="primary" (click)="onCancel()"
        class="!px-4 [--mdc-outlined-button-container-height:40px] md:[--mdc-outlined-button-container-height:48px]"
        [ngClass]="data.compactActions ? '!font-light' : 'md:!min-w-[244px]'"
        [id]="data.cancelId || ''" [attr.test-id]="data.cancelTestId || ''">
        {{ data.cancelText }}
      </button>
    }
    <button mat-flat-button color="primary" (click)="onConfirm()"
      class="!px-4 [--mdc-filled-button-container-height:40px] md:[--mdc-filled-button-container-height:48px]"
      [ngClass]="data.compactActions ? '!font-light' : 'md:!min-w-[244px]'"
      [id]="data.confirmId || ''" [attr.test-id]="data.confirmTestId || ''">
      @if (data.confirmIcon) {
        <mat-icon class="material-symbols-outlined">{{ data.confirmIcon }}</mat-icon>
      }
      {{ data.confirmText || ('Confirm' | translate) }}
    </button>
  </div>
</app-dialog-footer>
